export const searchParametersKey = 'navigation_search_parameters';
export const searchIdKey = 'navigation_search_id';
export const listingUrlKey = 'navigation_listing_url';
export const itemsKey = 'navigation_items';

/**
 * Local storage key which shares the `genericSearchFilters` with ekhaya for
 * the trackings of Homepage recommender.
 */
export const GENERIC_SEARCH_FILTERS_STORAGE_KEY = 'data_generic_search_filters';
